<template>
  <div>
    <h3 v-if="!functionalityName && !isPromoCodeDetails" :id="bookmakerName2 
          ? 'funkcjonalnosci-' + bookmakerName.toLowerCase() + '-' + bookmakerName2.toLowerCase() 
          : 'funkcjonalnosci-' + bookmakerName.toLowerCase()" 
        class="!my-6 !ml-2 !text-[28px] !font-semibold xl:!ml-0 xl:!mt-0">
      Funkcjonalności {{ bookmakerName }}
      <span v-if="bookmakerName2"> vs {{ bookmakerName2 }}</span>
    </h3>
    <div v-if="description && !functionalityName && !isPromoCodeDetails" class="mb-8 px-2 font-medium">
      <span class="mx-auto text-justify break-words tracking-[0.03em] font-light leading-[27px]" v-html="description"></span>
    </div>
    <div class="relative bg-zt-dark rounded-zt border-zt-light xl:mx-0"
         :class="[
          { 'border': !isPromoCodeDetails },
          isPromoCodeDetails ?
            !isLoading && 'py-4 xl:pb-4 xl:pl-[104px] xl:pr-28 xl:px-4 xl:pt-4'
            : '-mx-2 mb-5 py-[22px] px-5 xl:pb-[30px] xl:px-7 xl:mx-0 xl:pt-[30px]',
         ]">
      <bookmaker-rating-modal v-if="isModalOpen" 
                              @close-modal="closeModal"
                              :selectedItemName="selectedItemName"
                              :ratingType="selectedItemType"
                              :bookmakerName="selectedBookmakerName"
                              :functionalityName="functionalityName" />
      <h3 v-if="functionalityName" :id="bookmakerName
          ? functionalityName.toLowerCase() + '-' + bookmakerName.toLowerCase()
          : functionalityName.toLowerCase()" class="!-mt-2">{{ functionalityName }}</h3>
      <div v-if="!functionalityName" id="bookmaker-rating-os" class="overflow-x-scroll os xl:overflow-x-auto">
        <template v-if="isPromoCodeDetails && isLoading">
          <div class="w-full flex justify-center items-center gap-12 mt-8">
            <div class="h-5 w-14 rounded-zt"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            <div class="h-5 w-14 rounded-zt"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            <div class="h-5 w-14 rounded-zt"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
          </div>
          <div class="w-full px-2.5 xl:grid xl:grid-cols-2 xl:gap-x-10 xl:gap-y-5 xl:px-[120px]">
            <div class="w-full flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-1/2 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="only-mobile w-[98%] h-2.5 rounded-zt mt-1"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            <div class="w-full flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-2/5 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="only-mobile w-[98%] h-2.5 rounded-zt mt-1"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="w-full flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-2/6 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="only-mobile w-[98%] h-2.5 rounded-zt mt-1"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="w-full flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-7/12 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="only-mobile w-[98%] h-2.5 rounded-zt mt-1"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="w-full flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-2/5 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="only-mobile w-[98%] h-2.5 rounded-zt mt-1"
                style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            <div class="w-full only-desktop-flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-1/2 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="w-full only-desktop-flex justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-1/2 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
            <div class="only-desktop-flex w-full justify-between items-center mt-8">
              <div class="w-full flex items-center gap-1.5">
                <div class="w-1/2 rounded-zt h-7 xl:h-6"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
                <div class="h-2.5 w-2.5 rounded-zt"
                    style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
              </div>
              <div class="h-4 w-6 rounded-zt"
                  style="background: linear-gradient(90deg, #283444 -24.18%, #212D3C 50.26%, #2F4055 114.84%)"></div>
            </div>
          </div>
        </template>
        <div v-else class="flex items-center bg-zt-dark text-xs font-medium pb-2 overflow-content-mobile
               xl:justify-center xl:text-sm xl:gap-x-4 xl:pb-0"
             :class="bookmakerName2 || isPromoCodeDetails ? 'gap-x-3 justify-center' : 'gap-x-1 justify-between'"  >
          <button v-if="!bookmakerName2 && !isPromoCodeDetails"
                  class="w-[82px] h-[34px] px-1 shrink-0 border border-zt-light rounded-zt text-center xl:w-[160px] xl:h-[37px]"
                  :class="ratingType === 'all' ? 'bg-[#31425A] border-[#31425A]' : 'hover:bg-zt-light/35'"
                  @click="ratingType = 'all'; countClicks('bookmaker_rating')">
            WSZYSTKIE
          </button>
          <button class="px-1 shrink-0 border border-zt-light rounded-zt text-center xl:w-[160px] xl:h-[37px]"
                  :class="[
                    ratingType === 'specials' ? 'bg-[#31425A] border-[#31425A]' : 'hover:bg-zt-light/35',
                    bookmakerName2 || isPromoCodeDetails ? 'w-[90px] h-[37px]' : 'w-[68px] h-[34px]',
                    isPromoCodeDetails && 'order-last'
                  ]"
                  @click="ratingType = 'specials'; countClicks('bookmaker_rating'); isPromoCodeDetails && countClicks('Kod promo Fortuna - analityka 1: FUNKCJONALNOŚCI BUKMACHERA')">
            {{ isPromoCodeDetails ? 'INNE' : 'GŁÓWNE' }}
          </button>
          <button class="px-1 shrink-0 border border-zt-light rounded-zt text-center xl:w-[160px] xl:h-[37px]"
                  :class="[
                    ratingType === 'bets' ? 'bg-[#31425A] border-[#31425A]' : 'hover:bg-zt-light/35',
                    bookmakerName2 || isPromoCodeDetails ? 'w-[91px]' : 'w-[69px]',
                    isPromoCodeDetails ? 'h-[37px]' : 'h-[34px]'
                  ]"
                  @click="ratingType = 'bets';  countClicks('bookmaker_rating'); isPromoCodeDetails && countClicks('Kod promo Fortuna - analityka 1: FUNKCJONALNOŚCI BUKMACHERA')">
            ZAKŁADY
          </button>
          <button class="px-1 shrink-0 border border-zt-light rounded-zt text-center xl:w-[160px] xl:h-[37px]"
                  :class="[
                    ratingType === 'bonuses' ? 'bg-[#31425A] border-[#31425A]' : 'hover:bg-zt-light/35',
                    bookmakerName2 || isPromoCodeDetails ? 'w-[90px]' : 'w-[68px]',
                    isPromoCodeDetails ? 'h-[37px]' : 'h-[34px]'
                  ]"
                  @click="ratingType = 'bonuses'; countClicks('bookmaker_rating'); isPromoCodeDetails && countClicks('Kod promo Fortuna - analityka 1: FUNKCJONALNOŚCI BUKMACHERA')">
            BONUSY
          </button>
        </div>
      </div>
      <div class="flex flex-col mt-4" 
           :class="[
             bookmakerName2 ? 'xl:flex-row xl:justify-center xl:flex-wrap' : 'xl:grid xl:grid-cols-2',
             isPromoCodeDetails ? 'xl:gap-y-3.5 xl:gap-x-6' : 'gap-y-3.5 xl:gap-x-7'
           ]">
        <template v-if="bookmakerName2" v-for="rating in ratingsToShow" :key="rating.name">
          <div v-if="window.size.mobile" class="text-xs text-zt-more flex gap-1 -mb-2">
            <span class="font-medium">Porównanie</span>
            <span class="font-semibold uppercase">{{ rating.name }}</span>
          </div>
          <bookmaker-rating-item :item="rating" 
                                 :bookmakerName="bookmakerName" 
                                 :isRatingComparison="true" 
                                 @open-modal="openModal" />
          <bookmaker-rating-item :item="rating" 
                                 :bookmakerName="bookmakerName2" 
                                 :isRatingComparison="true" 
                                 :isSecondBookie="true" 
                                 @open-modal="openModal" />
        </template>
        <template v-else-if="functionalityName" v-for="bookmakerRating in bookmakerRatings" :key="bookmakerRating.name">
          <bookmaker-rating-item :item="bookmakerRating" 
                                 :bookmakerName="bookmakerRating.name"
                                 :isFunctionalityRatings="true"
                                 :bookieWithBorder="bookmakerName"
                                 @open-modal="openModal"  />
        </template>
        <template v-else v-for="item in ratingsToShow" :key="item.name">
          <bookmaker-rating-item :item="item"
                                 @click="countClicks('Kody promocyjne - 6')"
                                 :bookmakerName="bookmakerNameFromProps ? bookmakerNameFromProps : bookmakerName"
                                 :isPromoCodeDetails="isPromoCodeDetails"
                                 @open-modal="openModal" />
        </template>
      </div>
      <div v-if="(!bookmakerName2 && ((window.size.mobile && ratings.length > 8) || (window.size.desktop && !isPromoCodeDetails && ratings.length > 12)))
            || (bookmakerName2 && ((window.size.mobile && ratings.length > 4) || (window.size.desktop && ratings.length > 6)))
            || (window.size.mobile && isPromoCodeDetails && ratings.length > 5)"
           class="flex items-center gap-1 zt-hover cursor-pointer mx-auto w-fit mt-4">
        <span class="uppercase text-zt-more underline text-sm"
              :class="{ 'hidden': !showAllButtonVisible[ratingType] }"
              @click="showAll">Rozwiń wszystkie</span>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import BookmakerRatingModal from '../modals/BookmakerRatingModal.vue';
import BookmakerRatingItem from '../BookmakerRatingItem.vue';

export default {
  name: 'BookmakerRating',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    BookmakerRatingModal,
    BookmakerRatingItem
  },
  props: {
    bookmakerNameFromProps: String,
    isPromoCodeDetails: Boolean
  },
  data() {
    return {
      ratings: [],
      bookmakerRatings: [],
      rating: null,
      ratingType: this.$attrs.buk2 ? 'specials' : (this.isPromoCodeDetails ? 'bets' : 'all'),
      showAllButtonVisible: {
        specials: true,
        bets: true,
        bonuses: true
      },
      description: '',
      isModalOpen: false,
      selectedItemName: '',
      selectedItemType: '',
      selectedBookmakerName: '',
      bookmakerName: this.$attrs.buk ?? '',
      bookmakerName2: this.$attrs.buk2 ?? '',
      functionalityName: this.$attrs.funkcjonalnosc ?? '',
      isLoading: true
    };
  },
  computed: {
    ratingsToShow() {
      if (!this.rating) {
        return [];
      }
      
      this.ratings = [];

      if (this.ratingType === 'all') {
        let allRatings = [];

        allRatings = allRatings.concat(
          JSON.parse(JSON.stringify(Object.values(this.rating['specials']))),
          JSON.parse(JSON.stringify(Object.values(this.rating['bets']))),
          JSON.parse(JSON.stringify(Object.values(this.rating['bonuses']))));

          this.ratings = Object.values(allRatings).sort((a, b) => {
            const aValue = typeof a.value === 'boolean' && a.value ? 11 : Number(a.value);
            const bValue = typeof b.value === 'boolean' && b.value ? 11 : Number(b.value);

            if (aValue === bValue) {
              return Number(b.priority) - Number(a.priority);
            } else {
              return bValue - aValue;
            }
          });
      } else {
        if (this.bookmakerName2) {
          this.ratings = Object.values(this.rating[this.ratingType])
            .filter(rating => rating.value || rating.value2)
            .sort((a, b) => this.comparePriority(a, b, true));
        } else {
          this.ratings = Object.values(this.rating[this.ratingType])
            .filter(rating => rating.value)
            .sort((a, b) => this.comparePriority(a, b));
        }
      }

      if (window.size.mobile) {
        const maxRatings = this.showAllButtonVisible[this.ratingType] && !this.isPromoCodeDetails
          ? (this.bookmakerName2 ? 4 : 8)
          : (this.isPromoCodeDetails && this.showAllButtonVisible[this.ratingType] ? 5 : this.ratings.length);

        return this.ratings.slice(0, maxRatings);
      } else {
        const maxRatings = this.showAllButtonVisible[this.ratingType] && !this.isPromoCodeDetails
          ? (this.bookmakerName2 ? 6 : 12)
          : this.ratings.length;

        return this.ratings.slice(0, maxRatings);
      }
    }
  },
  watch: {
    ratingType: {
      immediate: true,
      handler() {
        setTimeout(this.refreshTooltips, 200);
      }
    }
  },
  updated() {
    if (this.$el.querySelector('.os')) {
      this.initializeScrollbar('.os');
    }
  },
  mounted() {
    this.isUserWithAdminPanel = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
    if (this.functionalityName) {
      this.getFunctionalityRatings();
    } else {
      this.getRating();
      this.getDescription();
    }
  },
  methods: {
    getRating() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_get_bookmaker_rating',
          bookmaker: this.bookmakerNameFromProps ? this.bookmakerNameFromProps.toLowerCase() : this.bookmakerName.toLowerCase(),
          bookmaker2: this.bookmakerName2.toLowerCase()
        })
        .then(response => {
          this.rating = response.data.data;
          if (this.isPromoCodeDetails) {
            this.rating.bets.card_games = this.rating.specials.card_games;
            this.rating.bets.e_sports = this.rating.specials.e_sports;
            if (this.rating.specials.hasOwnProperty('card_games')) {
              delete this.rating.specials.card_games;
            }
            if (this.rating.specials.hasOwnProperty('e_sports')) {
              delete this.rating.specials.e_sports;
            }
          }
          this.isLoading = false;
          setTimeout(this.refreshTooltips, 200);
        });
    },
    getDescription() {
      axios
      .get(`/wp-json/acf/v3/posts/${this.WP.id}?_fields=acf.book_func_desc&acf_format=standard`)
      .then(response => {
        this.description = response.data.acf['book_func_desc'];
      });
    },
    getFunctionalityRatings() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_get_functionality_ratings',
          bookmaker_functionality: this.functionalityName.toLowerCase()
        })
        .then(response => {
          this.bookmakerRatings = response.data.data;
          this.sortItemsByValue();
        });
    },
    showAll() {
      this.showAllButtonVisible[this.ratingType] = false;
      this.countClicks('bookmaker_rating');
    },
    openModal(itemName, bookmakerName) {
      this.selectedItemName = itemName;
      this.selectedBookmakerName = bookmakerName;
      this.selectedItemType = null;

      let elementIdPrefix = '';

      if (!this.functionalityName) {
        const itemTypes = ['specials', 'bets', 'bonuses'];
        
        elementIdPrefix = this.isPromoCodeDetails 
          ? 'funkcjonalnosci-wyroznione-' + this.bookmakerNameFromProps.toLowerCase() 
          : 'funkcjonalnosci-' + this.bookmakerName.toLowerCase();

        if (this.bookmakerName2) {
          elementIdPrefix += '-' + this.bookmakerName2.toLowerCase();
        }

        for (const itemType of itemTypes) {
          for (const key in this.rating[itemType]) {
            if (this.rating[itemType][key].name === itemName) {
              this.selectedItemType = this.getItemTypeName(itemType);
              break;
            }
          }
          if (this.selectedItemType) {
            break;
          }
        }

      } else {
        const elementId = this.functionalityName.toLowerCase();
        elementIdPrefix = elementId;

        if (this.bookmakerName) {
          elementIdPrefix += '-' + this.bookmakerName.toLowerCase();
        }
      }

      this.isModalOpen = true;
      this.blockScrolling();
      this.smoothScrollToElement(elementIdPrefix);
    },
    closeModal() {
      this.isModalOpen = false;
      this.unblockScrolling();
    },
    getItemTypeName(itemType) {
      switch (itemType) {
        case 'specials':
          return 'Główne';
        case 'bets':
          return 'Zakłady';
        case 'bonuses':
          return 'Bonusy';
        default:
          return '';
      }
    },
    comparePriority(a, b, isAvg) {
      let aValue, bValue;

      if (isAvg) {
        aValue = a.value_avg;
        bValue = b.value_avg;
      } else {
        aValue = typeof a.value === 'boolean' && a.value ? 11 : Number(a.value);
        bValue = typeof b.value === 'boolean' && b.value ? 11 : Number(b.value);
      }

      if (aValue === bValue) {
        return Number(b.priority) - Number(a.priority);
      } else {
        return bValue - aValue;
      }
    },
    sortItemsByValue() {
      this.bookmakerRatings.sort((a, b) => {
        if (b.value === a.value) {
          return a.name.localeCompare(b.name);
        }
        return b.value - a.value;
      });
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 359px) {
  .overflow-content-mobile {
    overflow-x: auto;
  }
}
</style>
